interface LineGraphProps {
  data?: number[];
  width: number;
  height: number;
  isGrowing?: boolean;
  isReverse?: boolean;
}

const LineGraph = ({
  data,
  width,
  height,
  isGrowing = false,
  isReverse = false,
}: LineGraphProps) => {
  if (!data || !data.length) return null;
  const isGrowingNew = isReverse ? !isGrowing : isGrowing;

  const maxX = data.length - 1;
  const maxY = Math.max(...data);
  const offset = 6;

  const points = data.map((point, index) => {
    const x = (index / maxX) * width;
    const y = height - (point / maxY || 0) * height;
    return { x, y };
  });

  const generatePathData = (
    points: { x: number; y: number }[],
    yOffset = 0
  ) => {
    let pathData = `M ${points[0].x},${points[0].y + yOffset}`;
    for (let i = 0; i < points.length - 1; i++) {
      const start = points[i];
      const end = points[i + 1];
      const midX = (start.x + end.x) / 2;
      const controlPoint1 = { x: midX, y: start.y + yOffset };
      const controlPoint2 = { x: midX, y: end.y + yOffset };
      pathData += ` C ${controlPoint1.x},${controlPoint1.y} ${
        controlPoint2.x
      },${controlPoint2.y} ${end.x},${end.y + yOffset}`;
    }
    return pathData;
  };

  const pathData = generatePathData(points);
  const pathDataOffset = generatePathData(points, offset);

  const gradientId = "gradient-" + Math.random().toString(36);

  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`}>
      <defs>
        <linearGradient id={gradientId} x1="0" x2="0" y1="0" y2="1">
          <stop
            offset="0%"
            style={{
              stopColor: isGrowingNew ? "#3b82f6" : "#ef4444",
              stopOpacity: 0.4,
            }}
          />
          <stop
            offset="100%"
            style={{
              stopColor: isGrowingNew ? "#3b82f6" : "#ef4444",
              stopOpacity: 0.01,
            }}
          />
        </linearGradient>
      </defs>

      <path
        d={pathData}
        fill="none"
        stroke={isGrowingNew ? "#3b82f6" : "#ef4444"}
        strokeWidth="2"
      />
      <path d={pathDataOffset} fill="none" stroke="none" strokeWidth="2" />
      <path
        d={`${pathDataOffset} L ${points[points.length - 1].x},${height} L ${
          points[0].x
        },${height} Z`}
        fill={`url(#${gradientId})`}
      />
    </svg>
  );
};

export default LineGraph;
